import React from "react";

// Simple singleton loader for Google Maps script. Avoids loading multiple
// script tags when multiple map components mount.
const defaultUrl =
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyDtfgAc1X2E0xI3pGsVl_kjKglZsg5vwdA&v=3.exp&libraries=geometry,drawing,places";

function loadScript(url) {
  if (typeof window === "undefined") return Promise.reject();
  if (window._googleMapsLoadingPromise) return window._googleMapsLoadingPromise;

  window._googleMapsLoadingPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.maps) return resolve(window.google);

    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google);
    script.onerror = (e) =>
      reject(e || new Error("Failed to load Google Maps script"));
    document.head.appendChild(script);
  });

  return window._googleMapsLoadingPromise;
}

class GoogleMapsLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: !!(
        typeof window !== "undefined" &&
        window.google &&
        window.google.maps
      ),
    };
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
    if (this.state.loaded) return;
    const targetUrl = this.props.url || defaultUrl;
    loadScript(targetUrl)
      .then(() => {
        if (this._mounted) this.setState({ loaded: true });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Google Maps failed to load", err);
      });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    if (!this.state.loaded) return null;
    return this.props.children || null;
  }
}

export default GoogleMapsLoader;



// WEBPACK FOOTER //
// ./src/components/GoogleMapsLoader/index.js